import type { LucideIcon } from 'lucide-react';
import {
  Palette,
  Tag,
  Stethoscope,
  Factory,
  Box,
  Barcode,
  Hash,
  MapPin,
  User,
  StickyNote,
} from 'lucide-react';

const fieldIcon = (Icon: LucideIcon) => <Icon size={18} strokeWidth={2} />;

export const hospitalRecordFieldIcons = {
  color: fieldIcon(Palette),
  labelNo: fieldIcon(Tag),
  deviceDefinition: fieldIcon(Stethoscope),
  brand: fieldIcon(Factory),
  model: fieldIcon(Box),
  serialNumber: fieldIcon(Barcode),
  tagNumber: fieldIcon(Hash),
  location: fieldIcon(MapPin),
  owner: fieldIcon(User),
  notes: fieldIcon(StickyNote),
};
